module.exports = __webpack_public_path__ + "static/media/tags.a66639c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/tags.svg
// module id = 151
// module chunks = 1